//
// Copyright (c) 2026 Comcast
//

import { configureStore } from '@reduxjs/toolkit'
import rootReducer from 'reducers/rootReducer'
import { localStorageMiddleware } from 'utils/localStorage'
import { api } from 'api/api'
import listenerMiddleware from 'listenerMiddleware'
import 'listeners/listeners'

const middleware = [
  localStorageMiddleware,
  api.middleware,
]

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    // warn in console after 64ms (default is 32ms), only in debug environment
    immutableCheck: { warnAfter: 64 },
    serializableCheck: { warnAfter: 64 },
  })
    .prepend(listenerMiddleware.middleware)
    .concat(middleware),
  devTools: true,
  preloadedState: {},
})

export { store }
